module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-three2.58d8100.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-three2.png
// module id = s2SQ
// module chunks = 0